import { render } from "./appresource.vue?vue&type=template&id=5be995e2&scoped=true"
import script from "./appresource.vue?vue&type=script&lang=js"
export * from "./appresource.vue?vue&type=script&lang=js"

import "./appresource.vue?vue&type=style&index=0&id=5be995e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be995e2"]])

export default __exports__